import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "~/hooks/appSelector";
import { TemplateRequest } from "~/models/Commons ";
import { useGetCloudEnvironmentsQuery, useSelectGCloudEnvironmentsQuery } from "~/services/cloudenvironment";
import { useGetCloudProvisionerListWithPaginationQuery } from "~/services/cloudProvisioner";
import { useGetProvidersQuery } from "~/services/providers";
import { useGetComponentsQuery } from "~/services/vm/Components";
import {
  useSaveVmTemplatesMutation,
  useUpdateVmTemplatesMutation,
} from "~/services/vm/VmTemplate";
import { selectProvider } from "~/store/feature/Provider";
import { getDefaultQueryParams } from "~/Utils/Utils";

export const UseVmTemplateForm = (
  refetch: () => void,
  templateId: number | null,
) => {
  const navigate = useNavigate();

  const { data: providerData } = useGetProvidersQuery();

  const { data: provisionerData } =
    useGetCloudProvisionerListWithPaginationQuery({
      page: 0,
      size: 5000,
    });

  const [saveVmTemplates, { isLoading, isError }] =
    useSaveVmTemplatesMutation();

  const [updateVmTemplates] = useUpdateVmTemplatesMutation();

  const { cloudProviderName } = useAppSelector(selectProvider);

  const { data: cloudEnvData } = useGetCloudEnvironmentsQuery({
    page: 0,
    size: 9999,
    active: true,
  });
    const { data: selectCloudEnvData } = useSelectGCloudEnvironmentsQuery({
    page: 0,
    size: 9999
  });

  const { data: ConfigurationComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("vm-configuration")
  );

  const { data: ProvissioningComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("post-provisioning-operations")
  );

  const { data: PolicyComponentsData } = useGetComponentsQuery(
    getDefaultQueryParams("policies")
  );

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    resetField,
    trigger,
  } = useForm<TemplateRequest>({
    defaultValues: {
      cloudEnvironmentId: undefined,
      cloudProvisionerTemplateId: undefined,
      name: "",
      cpuCore: undefined,
      ram: undefined,
      storage: undefined,
      vmconfiguration: "",
      vmPostProviosiing: "",
      vmPolicy: "",
      components: undefined,
      os: "",
      description: "",
    },
  });

  // =========================
  // CREATE
  // =========================
  const submitForm = async (data: TemplateRequest) => {
    if (isLoading) return;

    try {
      const components: number[] = [
        data.vmconfiguration?.value ?? data.vmconfiguration,
        data.vmPostProviosiing?.value ?? data.vmPostProviosiing,
        data.vmPolicy?.value ?? data.vmPolicy,
      ].filter(Boolean) as number[];

      const payload: TemplateRequest = {
        ...data,
        components,
        cloudEnvironmentId: data.cloudEnvironmentId?.value,
        cloudProvisionerTemplateId:
          data.cloudProvisionerTemplateId?.value,
        os: data.os.value,
      };

      const response = await saveVmTemplates(payload).unwrap();

      if (response?.success) {
      
        refetch();

        navigate("/vm-template", {
          state: {
            success: response.success,
             response: response
          },
        });
      } 
    } catch (error: any) {
       navigate("/vm-template", {
          state: {
            error: error,
          },
        });

      console.error("submitForm error:", error);
    }
  };

  // =========================
  // UPDATE
  // =========================
  const updateForm = async (_data: TemplateRequest) => {
    try {
      const components: number[] = [
        _data.vmconfiguration?.value ?? _data.vmconfiguration,
        _data.vmPostProviosiing?.value ?? _data.vmPostProviosiing,
        _data.vmPolicy?.value ?? _data.vmPolicy,
      ].filter(Boolean) as number[];

      const payload: TemplateRequest = {
        ..._data,
        id: _data.id,
        components,
        cloudEnvironmentId:
          _data.cloudEnvironmentId?.value ?? _data.cloudEnvironmentId,
        cloudProvisionerTemplateId:
          _data.cloudProvisionerTemplateId?.value ??
          _data.cloudProvisionerTemplateId,
        os: _data.os?.value ?? _data.os,
      };

      const response = await updateVmTemplates({
        id: templateId!,
        data: payload,
      }).unwrap();

      if (response?.success) {
       

        navigate("/vm-template", {
          state: {
            success: response.success,
            response: response
          },
        });
         refetch();
      } else {
        throw new Error("Update failed");
      }
    } catch (error: any) {
        navigate("/vm-template", 
          {state: { error: error}
        });
    }
  };

  return {
    handleSubmit,
    control,
    errors,
    cloudProviderName,
    cloudEnvData,
    ConfigurationComponentsData,
    ProvissioningComponentsData,
    PolicyComponentsData,
    providerData,
    provisionerData,
    selectCloudEnvData,
    submitForm,
    updateForm,
    reset,
    setValue,
    watch,
    resetField,
    templateId,
    isLoading,
    isError,
    trigger,
  };
};